'use strict';

const scriptTag = document.querySelector('#bridge-fo-tracker');

const config = {
    apiUrl: scriptTag.getAttribute('data-bridge-tracking-api-url'),
    testMode: scriptTag.getAttribute('data-bridge-tracking-test-mode') !== 'false'
};

module.exports = config;
